import { render, staticRenderFns } from "./AiSubReportModal.vue?vue&type=template&id=20ec9584"
import script from "./AiSubReportModal.vue?vue&type=script&lang=js"
export * from "./AiSubReportModal.vue?vue&type=script&lang=js"
import style0 from "./AiSubReportModal.vue?vue&type=style&index=0&id=20ec9584&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports